import React, { Component } from "react";

// definim ordinea pe verticală (de jos în sus)
const formations = {
    '4-3-3': {
        GK: ['GK'],           // portari – după cerința ta
        D: ['FS', 'FCS', 'FCD', 'FD'],  // fundași
        M: ['MC'],                      // mijlocași
        I: ['IS', 'ID'],                // interi
        A: ['AS', 'AC', 'AD']           // atacanți
    }
}
const LinesOrder = {
    '4-3-3': {
        'A': 1,
        'I': 2,
        'M': 3,
        'D': 4,
        'GK': 5,
    }
}
const Order = {
    '4-3-3': {
        'GK': 1,
        'FS': 1,
        'FCD': 2,
        'FCS': 3,
        'FS': 4,
        'MC': 1,
        'ID': 2,
        'IS': 3,
        'AD': 1,
        'AC': 2,
        'AS': 3,
    }
}





export default class Field extends Component {

    render() {
        const { players = [] } = this.props;

        var positionsLinesOrder = LinesOrder[this.props.formation]
        const positionsOrder = Order[this.props.formation]

        const groupsDefinition = formations[this.props.formation]
        const grouped = players.reduce((acc, player) => {
            for (const [groupKey, positions] of Object.entries(groupsDefinition)) {
                if (positions.includes(player.position)) {
                    (acc[groupKey] ??= []).push(player);
                }
            }
            return acc;
        }, {});

        return (

            <div className="field-box">
                {Object.keys(groupsDefinition).map((v, k) => {
                    return <div key={k} className='positions-line' style={{ order: positionsLinesOrder[v] }}>
                        {groupsDefinition[v].map((u, j) => {
                            return <div className="position-box" style={{ order: positionsLinesOrder[u] }}>
                                {/* {u} */}
                                {
                                    players.map(p => {
                                        if (p.position === u) return <div className="player-name">{p.nickname}</div>
                                    })
                                }
                            </div>
                        })}
                    </div>
                })}
                {/* {Object.keys(grouped).length > 0 &&
                        Object.keys(grouped).map(((v, k) => {
                            console.log({ k, v })
                            return <div key={k} className='positions-line' style={{order: positionsLinesOrder[v]}}>
                                {grouped[v].map((u, j)=> {
                                    return <div>{j.nickname}</div>
                                })}
                            </div>
                        }))
                    } */}
            </div>

        );
    }
}
